module.exports = __webpack_public_path__ + "img/mi.047a8da3.jpg";